import './Footer.css';
import linkedin from '../assets/logo/linkedin.png';


function Footer() {
  return (
    <footer className="Footer">
      <div className="Footer-separator" />
      <div className="Footer-row">
        <p className="Footer-copyright">
          &copy;{new Date().getFullYear()} Insane Vegan, Inc. All Rights Reserved. 
        </p>
        {/*<div className="Footer-links">
          <a href="#terms">Terms</a>
          <a href="#privacy">Privacy</a>
        </div>*/}
        <a
          className="linkedinLink"
          href="https://www.linkedin.com/company/insane-vegan/"
          target="_blank"
          rel="noreferrer"
        >
          <img className="linkedinIcon" src={linkedin} alt="LinkedIn" />
        </a>

      </div>
    </footer>
  );
}

export default Footer;
